module.exports = __webpack_public_path__ + "static/media/email.93818dee.svg";